export default "__VITE_ASSET__DijGB51X__"